import _ from "lodash";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetOrder } from "../../actions/orders";
import close from "../../assets/cancel_w.svg";
import PopupComponent from "../../common/Popup";
import Table from "../../common/Table";
import { amountFormat, generateString } from "../../config/helper";
import { Quantity } from "../Cart/Products";
import ShopForTyres, { season_icons } from "../ShopForTyres";
const ProdDetailTable = ({ data, order, isEdit: isEditParent, products, setProducts, addNewProds, setAddNewProds }) => {
  const [isShowProducts, setIsShowProducts] = useState(false);
  const [isEdit, setIsEdit] = useState({});
  const dispatch = useDispatch();

  const columns = useMemo(() => [
    {
      header: "SKU",
      accessor: "SKU",
      width: 10,
    },
    {
      header: "Rim",
      accessor: "rim",
      width: 5,
    },
    {
      header: "Size",
      accessor: "Size",
      width: 8,
    },
    {
      header: "LI",
      accessor: "li",
      width: 5,
    },
    {
      header: "SR",
      accessor: "sr",
      width: 5,
    },
    {
      header: "LR",
      accessor: "lr",
      width: 5,
    },
    {
      header: "Pattern",
      accessor: "Pattern",
      width: 8,
    },
    {
      header: "Category",
      accessor: "category",
      width: 8,
      cell: (row) => (
        <img
          className={row?.category?.trim()?.toLowerCase()}
          src={season_icons[row?.category?.trim()?.toLowerCase()]}
          alt="season"
        />
      ),
    },
    {
      header: "Application",
      accessor: "appliction",
      width: 8,
    },
    {
      header: "Unit Price",
      accessor: "Unit Price",
      width: 10,
      cell: (row) => `$${parseFloat(row?.["Unit Price"]).toFixed(2)}`,
    },
    {
      header: "Quantity Ordered",
      accessor: "Quantity",
      width: 15,
      cell: (row) => {
        let indx = products.findIndex(
          (ele) => ele.product_id === row.product_id
        );

        if (indx > -1) {
          row.Quantity = products[indx].quantity;
        }

        return (
          <Quantity
            data={row}
            isEditParent={isEditParent}
            isEdit={isEdit[row.product_id]}
            setIsEdit={(bool) => setIsEdit({ [row.product_id]: bool })}
            action={(qty) => {
              let prods = [...products];
              let idx = prods.findIndex(
                (ele) => ele.product_id === row.product_id
              );
              if (row.product_id?.includes("_new")) {
                let new_prods = addNewProds
                idx = new_prods.findIndex(
                  (ele) => ele.product_id === row.product_id
                );
                if (idx > -1) {
                  new_prods[idx].Quantity = parseInt(qty);
                  new_prods[idx].Amount = Number(parseFloat(
                    parseFloat(qty) *
                    parseFloat(row["Unit Price"])
                  ).toFixed(1))
                  setAddNewProds(new_prods);
                }
              } else {
                dispatch({
                  type: GetOrder.CHANGED,
                  line_item: {
                    ...row,
                    Quantity: parseInt(qty),
                    Amount: parseFloat(qty) * parseFloat(row["Unit Price"]),
                  },
                  fromRow: true,
                });
                if (idx > -1) {
                  prods[idx].quantity = parseInt(qty);
                  // prods[idx].product_sku = row.SKU;
                  setProducts(prods);
                } else {
                  setProducts([
                    ...products,
                    {
                      product_id: row.product_id,
                      product_sku: row.SKU,
                      quantity: parseInt(qty),
                    },
                  ]);
                }
              }
            }}
          />
        );
      },
    },
    {
      header: "Amount",
      accessor: "Amount",
      width: 19,
      cell: (row) => `$${amountFormat(row?.["Unit Price"] * row?.Quantity)}`,
    },
    // eslint-disable-next-line
  ], [products, isEditParent, isEdit, data, order]);
  const origin_id = useSelector((state) => state?.orders?.storedOrder?.fd_origin_id);

  return (
    <div className="prod-detail">
      <Table
        columns={columns}
        data={data?.length > 0 ? data?.concat(addNewProds) : []?.concat(addNewProds)}
        showTotal={true}
        totalPrice={data?.reduce((acc, row) => { return acc + (row?.["Unit Price"] * row?.Quantity) }, 0) + _.sumBy(addNewProds, "Amount")}
        totalQuantity={_.sumBy(data, "Quantity") + _.sumBy(addNewProds, "Quantity")}
        isCancel={isEditParent}
        delete={(id) => {
          let idx = data.findIndex((ele) => ele.id === id);
          if (id?.includes("_new")) {
            let newProds = [...addNewProds];
            idx = newProds.findIndex((ele) => ele.id === id);
            if (idx > -1) {
              let prods = [...products];
              let prodId = addNewProds[idx].product_id;
              let idx1 = prods.findIndex((ele) => ele.product_id === prodId);
              if (idx1 > -1) {
                prods[idx].quantity = 0;
                setProducts(prods);
              }
              newProds.splice(idx, 1)
              setAddNewProds(newProds)
            }
          } else {
            if (idx > -1) {
              let prodId = data[idx].product_id;
              let prods = [...products];
              let idx1 = prods.findIndex((ele) => ele.product_id === prodId);
              if (idx1 > -1) {
                prods[idx].quantity = 0;
                setProducts(prods);
              } else {
                prods = [...prods, {
                  product_id: prodId,
                  quantity: 0
                }]
                setProducts(prods)
              }
              dispatch({
                type: GetOrder.CHANGED,
                line_item: {
                  id
                },
                isRemove: true
              });
            }
          }
        }}
        totalFill={order?.order_sales_nav?.Fill ?? data?.[0]?.total_fill ?? 0}
        orderEdit={isEditParent}
        orderEditAction={() => {
          setIsShowProducts((bool) => !bool);
        }}
      />
      <PopupComponent open={isShowProducts}
        className={origin_id || order?.fd_origin_id ? "table-popup" : "table-popup-sm"}
      >
        <img
          src={close}
          alt="close"
          className="close-prods"
          width={20}
          onClick={() => setIsShowProducts(false)}
        />
        <ShopForTyres
          noNav={true}
          fromOrder={true}
          origin_id={order?.fd_origin_id}
          fromOrderCart={(item) => {
            let obj = {
              product_id: item.id + "_new_" + generateString(4) + generateString(3),
              quantity: parseInt(item.quantity),
              unit_price: parseFloat(item.unit_price),
              product_sku: item.sku
            };
            dispatch({
              type: GetOrder.CHANGED,
              onlyChange: true
            })
            item.id = item.id + "_new_" + generateString(4) + generateString(3)
            item.product_id = item.product_id + "_new_" + generateString(4) + generateString(3)
            setAddNewProds([...addNewProds, {
              ...item, SKU: item.sku,
              Pattern: item.pattern,
              Size: item.size,
              "Unit Price": parseFloat(item.unit_price),
              Quantity: parseFloat(item.quantity),
              category: item.season,
              appliction: item.application,
              Amount: Number(parseFloat(
                parseFloat(item.quantity) *
                parseFloat(item.unit_price)
              ).toFixed(1))
            }])
            let idx = products.findIndex((ele) => ele.product_id === item.id);
            if (idx > -1) {
              let prods = [...products];
              prods[idx].quantity = parseInt(item.quantity);
              // prods[idx].product_sku = item.sku;
              setProducts(prods);
            } else {
              setProducts([...products, obj]);
            }
          }}
          line_items={data}
        />
      </PopupComponent>
    </div>
  );
};

export default ProdDetailTable;
